import { render, staticRenderFns } from "./RegisterBullets.vue?vue&type=template&id=4ea4f5d9&"
import script from "./RegisterBullets.vue?vue&type=script&lang=js&"
export * from "./RegisterBullets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports